import { Component, Input, OnDestroy, OnInit, inject } from '@angular/core';
import { NzModalService } from 'ng-zorro-antd/modal';
import { AppointmentServiceAddEditComponent } from '../appointment-service-add-edit/appointment-service-add-edit.component';
import { Observable, Subject } from 'rxjs';
import { Select, Store } from '@ngxs/store';
import { AppointmentState } from '../../../appointment.state';
import { RemoveAppointmentService } from '../../../appointment.actions';
import { TranslateService, TranslateModule, TranslatePipe } from "@ngx-translate/core";
import { AppointmentFacade } from "../../appointment-facade.service";
import { takeUntil } from "rxjs/operators";
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzSpaceModule } from 'ng-zorro-antd/space';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzAlertComponent } from 'ng-zorro-antd/alert';
import { CommonModule, AsyncPipe } from '@angular/common';
import { NgxPermissionsModule } from 'ngx-permissions';

@Component({
    selector: 'beautyapp-appointment-services',
    templateUrl: './appointment-services.component.html',
    styleUrls: ['./appointment-services.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        NzDividerModule,
        NzIconModule,
        NzButtonModule,
        NzGridModule,
        NzCardModule,
        NzSpaceModule,
        NzPopconfirmModule,
        NzTagModule,
        NzAlertComponent,
        TranslateModule,
        TranslatePipe,
        AsyncPipe,
        NgxPermissionsModule
    ]
})
export class AppointmentServicesComponent implements OnDestroy {
  private modalService = inject(NzModalService);
  private store = inject(Store);
  private translateService = inject(TranslateService);
  apartmentFacade = inject(AppointmentFacade);

  @Input() employee: any;
  @Input() serviceStartTime: any;
  @Input() isSpecial: boolean = false;
  data: any[] = [];
  list: Array<{ loading: boolean; name: any }> = [];
  sub$: Subject<any> = new Subject<any>();
  selectedServices: any[] = [];

  ngOnDestroy(): void {
    this.sub$.next(null);
    this.sub$.complete();
  }


  addEditService(appointmentService: any = null, i?: number) {
    console.log(this.apartmentFacade.getCurrentEmployee)
    this.modalService.create({
      nzClosable: false,
      nzMaskClosable: false,
      nzTitle: this.translateService.instant('calendar.addProcedure'),
      nzContent: AppointmentServiceAddEditComponent,
      nzWidth: '1000px',
      nzStyle: { top: '0px' },
      nzBodyStyle: { padding: '10px' },
      nzData: {
        serviceIndex: i,
        appointmentService: appointmentService,
        bookingId: this.apartmentFacade.bookingId,
        bookingStatus: this.apartmentFacade.status,
        isSpecial: this.isSpecial,
        employee: this.apartmentFacade.getCurrentEmployee,
        serviceStartTime: this.serviceStartTime,
      },
      nzOnOk: () => {},
    });
  }

  delete(row: any, i: number) {
    this.apartmentFacade.deleteService(row, i)
      .pipe(takeUntil(this.sub$))
      .subscribe();
  }
}
